import { LegalDocumentPage } from "@/v2/components/LegalDocumentPage";
import { privacyPolicySections } from "./content";

export default function PrivacyPolicy() {
  return (
    <LegalDocumentPage
      title="Privacy Policy"
      subtitle="Please read these terms carefully before using this site."
      sections={privacyPolicySections}
    />
  );
}
